import { filterConstants } from "../../constants";
import {
  useApiPagedMetaSync,
  useGetPageQueryParams,
  useAdminApiQueryWithParams,
  useQueryString,
  useReactRouterLink,
} from "../../hooks";
import {
  IQueryStringNavLinks,
  ITableHeader,
  IPageAndSearchRequest,
  IViewInterProcessorSingleTransfer,
  PagedMeta,
} from "../../interfaces-and-types";
import { View } from "./View";

interface IProcessorBalanceQueryMeta {
  // status: string;
}

export interface IProcessorBalanceViewProps {
  data: IViewInterProcessorSingleTransfer[];
  headers: ITableHeader[];
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  openCreateNewModal: () => void;
  openDetailsModal: (id: any) => void;
  refreshTable: () => void;

  // extra buttons
  onExport: () => void;
}

export const InterProcessorTransfers = () => {
  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);
  const { page, page_size, search } = useGetPageQueryParams();

  const { navigateToRoutePreserveParams } = useReactRouterLink();

  const {
    isLoading: isLoadingProcessorBalances,
    isError: isErrorProcessorBalances,
    data: interProcessorSingleTransfers,
    meta: interProcessorSingleTransfersMeta,
    refetch: refetchInterProcessorSingleTransfers,
  } = useAdminApiQueryWithParams<
    IPageAndSearchRequest & IProcessorBalanceQueryMeta,
    IViewInterProcessorSingleTransfer[],
    PagedMeta
  >([
    "listInterProcessorSingleTransfers",
    {
      page: (page && Number(page)) || 1,
      page_size: (page_size && Number(page_size)) || 10,
      search,
      // status: status || "successful",
    },
  ]);

  useApiPagedMetaSync(interProcessorSingleTransfersMeta?.page_meta);

  const headers: ITableHeader[] = [
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "gateway_fee",
      header: "Fee",
    },
    // {
    //   key: "currency",
    //   header: "Currency",
    // },
    {
      key: "status",
      header: "Status",
    },
    // {
    //   key: "description",
    //   header: "Description",
    // },
    {
      key: "gateway",
      header: "From",
    },
    {
      key: "destination_gateway",
      header: "To",
    },
    {
      key: "destination_bank",
      header: "Dest. Bank",
    },
    {
      key: "destination_gateway_merchant_name",
      header: "Dest. Merch. Name",
    },
    // {
    //   key: "created",
    //   header: "Created",
    // },
    {
      key: "completedOn",
      header: "Sent",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "Successful",
        value: "successful",
      },
      {
        key: "Processing",
        value: "processing",
      },
      // {
      //   key: "Refunded",
      //   value: "refunded",
      // },
      {
        key: "Failed",
        value: "failed",
      },
    ],
  };

  const onExport = () => {
    alert("exporting data...");
  };

  const openCreateNewModal = () => navigateToRoutePreserveParams(`move-funds`);

  const openDetailsModal = (id: any) =>
    navigateToRoutePreserveParams(`${id}/details`);

  return (
    <View
      data={interProcessorSingleTransfers || []}
      headers={headers}
      isLoading={isLoadingProcessorBalances}
      isError={isErrorProcessorBalances}
      totalCount={interProcessorSingleTransfersMeta?.page_meta.item_count || 0}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      openCreateNewModal={openCreateNewModal}
      openDetailsModal={openDetailsModal}
      refreshTable={refetchInterProcessorSingleTransfers}
    />
  );
};
